import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ServerErrorDialogComponent } from '../server-error-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ServerErrorDialogService {
  private _dialogRef: MatDialogRef<ServerErrorDialogComponent> | null = null;

  private _dialog: MatDialog = inject(MatDialog);

  public showServerErrorDialog (): void {
    if (!this._dialogRef) {
      this._dialogRef = this._dialog.open(ServerErrorDialogComponent);
      this._dialogRef.afterClosed().subscribe(() => {
        this._dialogRef = null;
      });
    }
  }
}
